import clsx from 'clsx';
import React, { ReactNode } from 'react';
import { MBTextBody1 } from '@shared/components/typography';
import { Colors } from '@shared/styles';
import styles from './DropdownListItem.module.css';

interface DropdownListItemProps {
  children: ReactNode;
  onPress: () => void;
  endContent?: ReactNode;
  className?: string;
}

export function DropdownListItem({
  children,
  onPress,
  endContent,
  className,
}: DropdownListItemProps) {
  return (
    <div
      onClick={onPress}
      onKeyPress={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          onPress();
        }
      }}
      tabIndex={0}
      className={clsx(styles.item, className)}
    >
      <MBTextBody1 color={Colors.v2.purple}>{children}</MBTextBody1>
      {endContent}
    </div>
  );
}
